module.exports = __webpack_public_path__ + "static/img/icon01.b1e02201.svg";